import { Injectable } from "@angular/core";
import { ITranslateObject, TaxprepT1Card } from "../views-interfaces";
import { TextInputModel } from "./filter-types";

@Injectable({
    providedIn: "root",
})
export class GroupnameFilterGeneratorService {
    constructor() {}

    generateModel(input: string) {
        // TODO remove selected items that are no longer in options list
        return {
            label: "FiltersSidebar.Labels.GroupName",
            text: input,
        } as TextInputModel;
    }

    getPrintDescription(label: string | ITranslateObject, selectedValue: string): { label: string | ITranslateObject; values: string[] } | null {
        if (!selectedValue || selectedValue.length === 0) {
            return null;
        } else {
            return {
                label,
                values: [selectedValue],
            };
        }
    }

    generateFilter(input: string) {
        if (!input || input.length === 0) {
            return null;
        } else {
            return (card: TaxprepT1Card) => {
                return card?.groupName?.toLowerCase()?.indexOf(input?.toLowerCase()) > -1;
            };
        }
    }
}
